import { css } from 'styled-components';

// A lit surface: broad reflected light, a quiet lower edge, and diffuse elevation.
export const softSurface = css`
  border: 0;
  border-radius: 12px;
  background:
    radial-gradient(ellipse at 8% 0%, #ffffff 0%, #ffffff00 64%),
    radial-gradient(ellipse at 100% 100%, #e9ecee66 0%, #e9ecee00 62%),
    linear-gradient(145deg, #fafbfb, #f7f8f8 55%, #f3f5f5);
  box-shadow:
    inset 0 1px 0 #fff,
    inset 0 -1px 1px #202b3505,
    0 2px 4px #202b3502,
    0 12px 28px -18px #202b3518,
    0 32px 64px -40px #202b351c;
`;
